// extracted by mini-css-extract-plugin
export default {"input":"InputNumber_input__tbrSJ","hideNumberArrows":"InputNumber_hideNumberArrows__tPvfF","select":"InputNumber_select__u+KED"};